import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { HttpService } from './http.service';
import { BehaviorSubject, Observable, Subject } from 'rxjs';

export interface PushNotificationPayload {
  title: string;
  body: string;
  deviceToken: string;
  /** true = Android (mirrors the user's isDeviceTypeAndroid). */
  deviceType: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  private notification = new BehaviorSubject<any>({});
  /** Fires when notifications change server-side (e.g. a push arrived). */
  private changed = new Subject<void>();

  constructor(private httpService: HttpService) {}
  /**
   * Sends a push notification to a single device.
   * `skipToast` suppresses the global error toast (bulk sends report their own summary).
   */
  sendPushNotification(payload: PushNotificationPayload, skipToast = false) {
    const headers = skipToast
      ? new HttpHeaders({ 'X-Skip-Toast': 'true' })
      : undefined;

    return this.httpService.post(
      'api/Authentication/SendPushNotification',
      payload,
      { headers }
    );
  }
  setCount(data: any) {
    this.notification.next(data);
  }
  getCount(): Observable<any> {
    return this.notification.asObservable();
  }
  notifyChanged() {
    this.changed.next();
  }
  onChanged(): Observable<void> {
    return this.changed.asObservable();
  }
  getNotifications(payload: any) {
    return this.httpService.getList(
      `api/Notification/GetNotification/${payload?.userid}`,
      payload
    );
  }
  getNotificationsCount(payload: any) {
    return this.httpService.getList(
      `api/Notification/GetNotificationCount/${payload?.userid}`,
      payload
    );
  }
  assignedEmployeeCount(payload: any) {
    return this.httpService.getList(
      `api/User/assignedEmployeeCount`,
      payload
    );
  }
   notificationMarkAllAsRead(payload: any) {
    return this.httpService.put(
      `api/Notification/notification/MarkAllAsRead`,
      payload
    );
  }
  notificationMarkAsRead(payload: any) {
    return this.httpService.put(
      `api/Notification`,
      payload
    );
  }

}
